function CustomerProfile() {
  return (
    <div className="page">
      <h1>Customer Profile</h1>
      <p>My details and booking history.</p>
    </div>
  );
}

export default CustomerProfile;
